import { useQuery } from "@tanstack/react-query";
import { UserService } from "src/services";
import { queryKeys } from "src/constants";

export const useUserSettings = (userService: UserService) => {
  const {
    data: settingsData,
    error: fetchError,
    isLoading,
    refetch
  } = useQuery({
    queryKey: queryKeys.userSettings(),
    queryFn: () =>
      userService.getUserCurrentSettings().then(({ userName, userSettings }) => ({
        userName,
        userSettings
      })),
    retry: false
  });

  const userName = settingsData?.userName;
  const userSettings = settingsData?.userSettings;

  return {
    userName,
    userSettings,
    fetchError,
    isLoading,
    refetch
  };
};
